var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoundedBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.875 15.2996L0.275 8.69959C0.175 8.59959 0.104 8.49126 0.0619998 8.37459C0.0206665 8.25793 0 8.13293 0 7.99959C0 7.86626 0.0206665 7.74126 0.0619998 7.62459C0.104 7.50793 0.175 7.39959 0.275 7.29959L6.875 0.699594C7.05833 0.516261 7.28733 0.420261 7.562 0.411594C7.83733 0.403594 8.075 0.499594 8.275 0.699594C8.475 0.882927 8.57933 1.11193 8.588 1.38659C8.596 1.66193 8.5 1.89959 8.3 2.09959L3.4 6.99959H14.575C14.8583 6.99959 15.096 7.09526 15.288 7.28659C15.4793 7.47859 15.575 7.71626 15.575 7.99959C15.575 8.28293 15.4793 8.52026 15.288 8.71159C15.096 8.90359 14.8583 8.99959 14.575 8.99959H3.4L8.3 13.8996C8.48333 14.0829 8.57933 14.3163 8.588 14.5996C8.596 14.8829 8.5 15.1163 8.3 15.2996C8.11667 15.4996 7.88333 15.5996 7.6 15.5996C7.31667 15.5996 7.075 15.4996 6.875 15.2996Z",
    fill: "black",
    fillOpacity: 0.38
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundedBack);
export default __webpack_public_path__ + "static/media/RoundedBack.8954b83dda11a24396464cb0e5a30990.svg";
export { ForwardRef as ReactComponent };